(() => {
  if (window.__orzaCartOffersReady) return;
  window.__orzaCartOffersReady = true;
  const track = (event, data = {}) => { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event, offer_surface: 'cart_drawer', ...data }); };
  const root = window.Theme?.routes?.root_url || window.Shopify?.routes?.root || '/';
  const refreshDrawer = async () => {
    const response = await fetch(root + '?sections=cart-drawer-section', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    const sections = await response.json();
    const wrapper = document.getElementById('shopify-section-cart-drawer-section');
    if (!wrapper || !sections['cart-drawer-section']) { window.location.reload(); return; }
    wrapper.outerHTML = sections['cart-drawer-section'];
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer?.open) drawer.open();
  };
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-orza-cart-bump]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button?.disabled) return;
    const data = new FormData(form);
    const offer = form.dataset.offer || 'unknown';
    const offerShell = form.closest('[data-orza-cart-offer]');
    const addingLabel = offerShell?.dataset.orzaCartAdding || 'Adding…';
    const retryLabel = offerShell?.dataset.orzaCartTryAgain || 'Try again';
    const errorLabel = offerShell?.dataset.orzaCartError || 'Unable to add the pouch.';
    track('orza_cart_bump_selected', { offer, quantity: Number(data.get('quantity') || 1) });
    if (button) { button.disabled = true; button.textContent = addingLabel; }
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data, credentials: 'same-origin' });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add the pouch.');
      track('orza_cart_bump_accepted', { offer, quantity: Number(data.get('quantity') || 1) });
      await refreshDrawer();
    } catch (error) {
      if (button) { button.disabled = false; button.textContent = retryLabel; }
      const message = document.createElement('p'); message.setAttribute('role', 'alert'); message.textContent = error.message || errorLabel; form.append(message);
    }
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-orza-cart-decline]')) track('orza_cart_bump_declined', { offer: 'one_more_pouch' });
    if (event.target.closest('cart-drawer-component button[name="checkout"], cart-drawer-component a[href*="/checkout"]')) track('orza_checkout_started', { source: 'cart_drawer' });
  });
  document.addEventListener('dialog:after-show', (event) => { if (event.target?.id === 'cart-drawer') track('orza_cart_bump_view', { offer: 'one_more_pouch' }); });
})();
